module.exports = __webpack_public_path__ + "static/media/la2a-bg-2.9c50a8a2.png";